import { makeStyles } from '@material-ui/core/styles';
import loadingJson from '../assets/images/lottieJson/loading.json';
import LottieImage from './shared/LottieImage';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
  },
}));

export default function Loading() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <LottieImage animationData={loadingJson} width={467} height={375} />
    </div>
  );
}
